// extracted by mini-css-extract-plugin
export default {"root":"classes_root__ATn2r","type-selector":"classes_type-selector__NBXeC","label":"classes_label__TSSW4","selected-underline":"classes_selected-underline__f8Adt"};